export const i18n: any = {
    en: {
        placeholder: 'Select the models you want to compare',
    },
    cn: {
        placeholder: '请选择产品',
    },
    jp: {
        placeholder: 'モデルを選択してください',
    },
    kr: {
        placeholder: '모델을 선택하세요',
    },
    tw: {
        placeholder: '請選擇產品',
    },
    de: {
        placeholder: 'Wählen Sie die Modelle aus, die Sie vergleichen möchten',
    },
    fr: {
        placeholder: 'Sélectionnez les modèles que vous souhaitez comparer',
    },
    it: {
        placeholder: 'Seleziona i modelli che vuoi confrontare',
    },
    es: {
        placeholder: 'Seleccione los modelos que quiere comparar',
    },
    br: {
        placeholder: 'Selecione os modelos que deseja comparar',
    },
    mx: {
        placeholder: 'Escoja los modelos que desea comparar',
    },
    sa: {
        placeholder: 'حدد النماذج التي تريد مقارنتها',
    },
    nl: {
        placeholder: 'Selecteer de modellen die u wilt vergelijken.',
    },
};
